<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div
      class="flex-grow-1"
      :class="$s('appStyle.backgroundClass')"
      role="main"
    >
      App Id : {{ $s("INSTANCE_ID") }}
      <SessionHandler />
    </div>
    <TheFooter />
    <TheToolkit />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import TheNavbar from "@/components/core/TheNavbar.vue";
import TheToolkit from "@/dev/components/TheToolkit.vue";

import SessionHandler from "@/components/core/SessionHandler.vue";

export default {
  name: "App",
  components: {
    TheHeader,
    TheNavbar,
    TheFooter,
    SessionHandler,
    TheToolkit
  }
  /*
    getONID() {
      window.BugHerdConfig = window.BugHerdConfig || {};
      window.BugHerdConfig.feedback = { tab_position: "bottom-left" };
      window.BugHerdConfig.reporter = window.BugHerdConfig.reporter || {};
      window.BugHerdConfig.reporter.required = "true";
      window.BugHerdConfig.reporter.email = `${this.getONID}@oregonstate.edu`;
    }
      */
};
</script>
